$(function () {
  function initLocationMap() {
    const script_src = "https://api.mapbox.com/mapbox-gl-js/v2.12.0/mapbox-gl.js";
  
    var script = document.createElement("script");
    script.src = script_src;
  
    document.body.appendChild(script);
  
    script.onload = function () {
      mapboxgl.accessToken =
        "pk.eyJ1IjoiaW5kdXN0cmlvdXMiLCJhIjoiY2xjcnRtajA5MGpoaDNuazZrdmxxdzY2bSJ9.L1eb2m-ZarARv36rKMgxcQ";
  
      const setOffsetLng = (map) => {
        let stretch = map[0].classList.contains("stretch-image");
  
        if (!stretch) return 0;
        if (window.innerWidth > 1600) return 0;
        if (window.innerWidth > 1200) return 0.005;
        if (window.innerWidth > 767) return 0.01;
  
        return 0;
      };
      let $locationMap = $("#locationMap");
      if ($locationMap.length > 0) {
        let $offsetTopMap = $locationMap.offset().top;
        let isMapCreated = false;
  
        //lazy loading map
  
        let scrollWindow = $(window).scrollTop();
  
        let lat = $locationMap.data("lat");
        let lng = $locationMap.data("lng");
  
        let offsetLng = setOffsetLng($locationMap);
  
        //Init Map
        const map = new mapboxgl.Map({
          container: "locationMap",
          style: "mapbox://styles/mapbox/light-v10",
          center: [parseFloat(lng) + offsetLng, parseFloat(lat)],
          zoom: 14,
        });
  
        map.scrollZoom.disable();
  
        map.on("load", () => {
          map.addSource("location", {
            type: "geojson",
            data: {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: [lng, lat],
              },
            },
          });
  
          // Set marker options.
          map.addLayer({
            id: "unclustered-point",
            type: "circle",
            //type: 'symbol', // For Icon
            source: "location",
            filter: ["!", ["has", "point_count"]],
            // layout: { // For Icon
            //   'icon-image': 'map-icon'
            // },
            paint: {
              "circle-radius": 8,
              "circle-color": "#013e3f",
            },
          });
        });
  
        isMapCreated = true;
      }
    };
  }

  initLocationMap();
});
